import { dateToApiDate } from "~/utils/date-util";
import { BaseAPI } from "./base";
import type {
  TagAndKeyRequest,
  TagDataCreateDto,
  TagDataTimeSeriesDto,
} from "~/types/api";
import type { ApiResponse, DateRange } from "~/types/ui";

export class NodeDataApi extends BaseAPI {
  async getTimeSerie(
    deveui: string,
    key: string,
    dateRange: DateRange,
  ): Promise<ApiResponse<TagDataTimeSeriesDto[]>> {
    const sensor = encodeURIComponent(key);
    const start = dateToApiDate(dateRange.from);
    const end = dateToApiDate(dateRange.to);

    return this.get<TagDataTimeSeriesDto[]>(
      `tagData/timeseries/${deveui}/${sensor}/${start}/${end}`,
    );
  }

  /**
   * Bulk variant of `getTimeSerie` — one request for many deveui+key pairs instead of
   * one request per pair. Returns a flat `TagDataTimeSeriesDto[]` covering every
   * requested pair (same row shape `getTimeSerie` already returns, just concatenated —
   * each row still carries its own `deveui`/`key` so callers group client-side).
   */
  async getMultipleTimeSeries(
    pairs: TagAndKeyRequest[],
    dateRange: DateRange,
  ): Promise<ApiResponse<TagDataTimeSeriesDto[]>> {
    const start = dateToApiDate(dateRange.from);
    const end = dateToApiDate(dateRange.to);

    return this.post<TagDataTimeSeriesDto[]>(
      `tagdata/timeseries/${start}/${end}`,
      pairs,
    );
  }

  async createTagData(
    deveui: string,
    payload: TagDataCreateDto,
  ): Promise<ApiResponse<void>> {
    return this.post<void>(`tag/${deveui}/tagdata`, payload);
  }
}
